/*****************************************************************
 *  History Events
 * ***************************************************************/

export const USER_CONNECTED = "USER_CONNECTED"
export const USER_DISCONNECTED = "USER_DISCONNECTED"
export const TOKEN_EXPIRED = "TOKEN_EXPIRED"
export const IGNORE_EXPIRED_TOKEN = "IGNORE_EXPIRED_TOKEN"
export const ADD_USER_NAME = "ADD_USER_NAME"
export const SET_LIVE_ACCESS = "SET_LIVE_ACCESS"
export const ADD_DENIED_SERVICE = "ADD_DENIED_SERVICE"